/* eslint-disable */
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'md-showHideFactory',
  template: require('./showHideFactory.component.html')
})

export class ShowHidefactoryComponent {
  @Input() inputFields;
  @Input() showUp;
  @Output() valueChange = new EventEmitter();

  updateOptionValue(event) {
    this.valueChange.emit(event);
  }

  formBtnClicked(event) {
    this.valueChange.emit(event);
  }
}
